import React, { useEffect, useState } from 'react'
import './styles/CustomAlert.css'
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckIcon from '@mui/icons-material/Check';

export default function CustomAlert({ handleClose, alertProps, show, props, toggle }) {

  const [alertID, setalertID] = useState("") //animation purposes

  useEffect(() => {
    //start timer for close
    setalertID("alert-in")
    setTimeout(() => {
      setalertID("alert-out")
      setTimeout(() => {
        handleClose()
      }, 2000);
    }, 2000);
  }, [])

  function getAlertType() {
    const lightColors = ['#f66561', '#0D82FF', '#4ee484'] //[red,blue,green] dceefa
    const darkColors = ['#ad345a', '#457ea1', '#446954'] //[red,blue,green] dceefa
    const alertIcons = [
      <ReportProblemOutlinedIcon className='alert-icon' sx={{ color: lightColors[alertProps.type] }} />,
      <InfoOutlinedIcon className='alert-icon' sx={{ color: lightColors[alertProps.type] }} />,
      <CheckIcon className='alert-icon' sx={{ color: lightColors[alertProps.type] }} />]

    return (
      <div className='alert-modal-body' style={{
        border: ` 1px solid ${lightColors[alertProps.type]}`,
        backgroundColor: 'white',
      }}>
        {alertIcons[alertProps.type]}
        <h5 style={{ color: 'black', fontWeight: 600 }}>{alertProps.message}</h5>
      </div>)
  }


  return (
    <div className='alert-modal-container' id={alertID} >
      {getAlertType()}
    </div>
  )
}

